import { LogoutOutlined } from "@ant-design/icons";
import { Form, Input, Drawer, Button, Col, Row, Menu, Dropdown } from "antd";
import { Header } from "antd/lib/layout/layout";
import React, { useState } from "react";
import { connect } from "react-redux";
import { logOut, updateOwn1Password } from "../actions/auth";
import history from "../history";
import { SettingOutlined, KeyOutlined } from "@ant-design/icons";
import Logo from "./fb.png";
import "./index.css";

const menu = (logOut, showDrawer) => (
  <Menu>
    <Menu.Item onClick={() => showDrawer()}>
      <KeyOutlined /> Password Setting
    </Menu.Item>
    <Menu.Item
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        
      }}
    >
      <Button  onClick={() => logOut()}><LogoutOutlined/>Logout</Button>
    </Menu.Item>
  </Menu>
);
const Topbar = ({ updateOwn1Password, logOut }) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  const onFinish = async (values) => {
    const code = await updateOwn1Password(values);
    if (code === 201) {
      form.resetFields();
      setVisible(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
  };
  return (
    <Header
      className="site-layout-background"
      style={{
        backgroundColor: "white",
        color: "#130808",
        marginBottom: "10px",
        boxShadow: "4px 3px 8px 0px rgba(0,0,0,0.10)",
       
        
      }}
    >
      <Row style={{ display: "flex", justifyContent: "space-between" }}>
        <Col sm={12} style={{ alignSelf: "center" }}>
          <img
            src={Logo}
            alt=""
            width="160px"
            style={{ cursor: "pointer", padding: "5px" }}
            onClick={() => history.push("/dashboard")}
          />
        </Col>
        <Col
          sm={12}
          style={{ alignSelf: "center", position: "absolute", right: "20px" }}
        >
          <span> {localStorage.getItem("name")}</span>
          &nbsp; &nbsp;
          <Dropdown overlay={menu(logOut, showDrawer)} placement="bottomRight">
            <Button type="primary" shape="circle" icon={<SettingOutlined />} />
          </Dropdown>
        </Col>
      </Row>
      <Drawer
        title="Update Own Password"
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        width="500"
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <Form.Item
            label="Old Password"
            name="old_password"
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="password"
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="Confirm Password"
            name="confirm_password"
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </Header>
  );
};

export default connect(null, { logOut, updateOwn1Password })(Topbar);
